import {Button, Grid} from '@logistics-frontend/blocks'
import {Drawer, DrawerSection} from '@logistics-frontend/blocks/legacy'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {AdvertInfoContent} from '../content'
import {AdvertModalProps as Props} from '../types'
import * as classes from './AdvertInfoMobile.classes'

function AdvertInfoMobile({onClose, content}: Props): React.ReactElement<Props> {
  const t = useI18n()

  return (
    <Drawer className={classes.root} expanderType="none" onClose={onClose} fitContent>
      <DrawerSection fullHeight>
        <Grid className={classes.content} direction="column" wrap="nowrap" container>
          <Grid item>
            <AdvertInfoContent contentItems={content} />
          </Grid>
          <Grid className={classes.trail} item>
            <Button onPress={onClose} fullWidth>
              {t('route.close')}
            </Button>
          </Grid>
        </Grid>
      </DrawerSection>
    </Drawer>
  )
}

export default AdvertInfoMobile
